import React, { Component, Fragment } from "react";
import { withRouter, Switch, Route, Redirect } from "react-router-dom";
import TagManager from "react-gtm-module";
import "./assets/styles/main.css";
import { isUserLoggedIn } from "./shared/helpers/user-helper";
import NavigationMiddleware from "./shared/navigation/navigation-middleware";
import { routes, routesArray } from "./shared/routes/index";
import DefaultLayout from "./shared/components/layouts/DefaultLayout";
import groupBy from "lodash/groupBy";
import SmartBannerWrapper from "./shared/components/banners/SmartBannerWrapper";
import BackTopButton from "./shared/components/buttons/BackTopButton";
import LeaderboardMobile from "./screens/challenges/LeaderboardMobile";
import LeaderboardPublic from "./screens/challenges/LeaderboardPublic";
import {
  isUniversalLink,
  mobileStoreRedirect,
} from "./shared/helpers/universal-link-helper.js";

class App extends Component {
  constructor(props) {
    super(props);
    if (isUniversalLink()) mobileStoreRedirect();
    NavigationMiddleware.apply();
    NavigationMiddleware.handleNavigation(window.location);
  }

  componentDidMount() {
    const tagManagerArgs = {
      gtmId: process.env.REACT_APP_GTM_ID,
    };
    TagManager.initialize(tagManagerArgs);
  }

  render() {
    return (
      <Fragment>
        <SmartBannerWrapper />
        {this.renderRootRoutes()}
        <BackTopButton />
      </Fragment>
    );
  }

  renderRootRoutes = () => {
    const rootRoutes = routesArray
      .filter((x) => x.rootPath)
      .map((r) => ({
        ...r,
        layout: r.layout || DefaultLayout,
      }));

    const directRoutes = routesArray
      .filter((x) => x.directRoute)
      .map((r) => ({
        ...r,
        layout: r.layout || DefaultLayout,
      }));

    const grouped = Object.values(groupBy(rootRoutes, (r) => r.layout));
    const direct = Object.values(groupBy(directRoutes, (r) => r.layout));

    return (
      <Switch>
        <Route
          exact
          path="/"
          render={({ location }) => {
            const { redirectedFrom } = location.state || {};
            return (
              <Redirect
                to={{
                  pathname: this.defaultRoute(),
                  state: { redirectedFrom },
                }}
              />
            );
          }}
        />
        <Route path="/leaderboard" render={() => <LeaderboardMobile />} />
        <Route
          path="/leaderboard-public"
          render={() => <LeaderboardPublic />}
        />
        {grouped.map((routes, key) => {
          const Layout = routes[0].layout;
          return (
            <Route
              key={key}
              path={this.getCombinedPaths(routes)}
              component={() => <Layout routes={routes} />}
            />
          );
        })}
        {direct.map((route, key) => {
          const Layout = route[0].layout;
          return (
            <Route
              key={key}
              path={route.path}
              component={() => <Layout routes={route} />}
            />
          );
        })}
      </Switch>
    );
  };

  defaultRoute = () =>
    isUserLoggedIn() ? routes.profile.path : routes.login.path;

  getCombinedPaths = (routes) =>
    `/(${routes.map((r) => r.path.replace("/", "")).join("|")})`;
}

export default withRouter(App);
